import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  inject,
  effect,
} from '@angular/core';
import { PermissionService } from '../../core/services/permission.service';

@Directive({
  selector: '[hasPermission]',
  standalone: true,
})
export class HasPermissionDirective {
  private readonly templateRef = inject(TemplateRef<any>);
  private readonly viewContainer = inject(ViewContainerRef);
  private readonly permissionService = inject(PermissionService);

  private permissions: string[] = [];
  private _requireAll = false;
  private isVisible = false;

  constructor() {
    effect(() => {
      this.permissionService.grantedPermissions();
      this.permissionService.isAdmin();
      this.updateView();
    });
  }

  @Input() set hasPermission(permissions: string | string[]) {
    this.permissions = Array.isArray(permissions) ? permissions : [permissions];
    this.updateView();
  }

  @Input('hasPermissionRequireAll')
  set requireAll(value: boolean) {
    this._requireAll = value;
    this.updateView();
  }
  private updateView(): void {
    const hasAccess = this.checkPermissions();

    if (hasAccess && !this.isVisible) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.isVisible = true;
    } else if (!hasAccess && this.isVisible) {
      this.viewContainer.clear();
      this.isVisible = false;
    }
  }

  private checkPermissions(): boolean {
    if (!this.permissions.length) {
      return true;
    }

    return this._requireAll
      ? this.permissionService.hasAllPermissions(this.permissions)
      : this.permissionService.hasAnyPermission(this.permissions);
  }
}
